import React from 'react'

import './style.scss'

const Button = (props) => {
  return (
    <button className={[(props.withIcon ? props.withIcon + ' ' : '') + (props.className ? props.className : '')]} onClick={props.onClick}>{props.title}</button>
  )
}

export default Button
